import {
  TablePage,
} from 'src/views/abi/htscode'
import pathMap from 'src/paths/pathMap'

class AbiHtsCodeRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_HTS_CODE_PATH,
        component: TablePage
      }
    ]
  }
}

export default AbiHtsCodeRoute
